<template>
  <div>
    <el-dialog
      ref="dialog"
      append-to-body
      :close-on-click-modal="false"
      :title="'Оценка пользователя ' + (evaluatee.evaluatee ? evaluatee.evaluatee.full_name : '')"
      :visible.sync="show"
      width="90%"
      destroy-on-close
    >
      <div v-loading="loading">
        <div v-if="competencies && competencies.length">
          <div v-for="competency in competencies" :key="competency.id" class="competency">
            <h2 class="competency-name">{{ competency.competence.name }}</h2>
            <p class="competency-desc" v-if="competency.competence.description">
              <strong>Описание компетенции: </strong>
              {{ competency.competence.description }}
            </p>
            <div
              v-for="indicator in competency.competence.indicators"
              :key="indicator.id"
              class="indicator"
            >
              <p class="indicator-name"><strong>{{ indicator.name }}</strong></p>
              <p class="indicator-desc" v-if="indicator.description">
                <strong>Описание индикатора: </strong>
                {{ indicator.description }}
              </p>
              <el-radio-group
                :disabled="disabled_evaluate()"
                class="evaluation-scale-radio"
                :value="selectedOptions[indicator.id]"
                @input="optionId => saveEvaluation(indicator.id, optionId)"
              >
                <div>
                  <el-radio
                    v-for="option in scale.options"
                    :key="option.id"
                    :label="option.id"
                  >
                    {{ option.value }}
                  </el-radio>
                </div>
              </el-radio-group>
              <el-input
                :disabled="disabled_evaluate()"
                type="textarea"
                placeholder="Комментарий"
                v-model="indicatorComments[indicator.id]"
                @blur="saveEvaluation(indicator.id, selectedOptions[indicator.id])"
                rows="2"
                class="comment"
                maxlength="10000"
                :autosize="{ minRows: 3, maxRows: 6}"
              />
            </div>
          </div>
        </div>
        <p v-else class="block-empty">
          <i class="fas fa-info-circle"></i>
          Компетенций в профиле не найдено
        </p>
        <div class="button-block">
          <el-button
            :disabled="loading"
            v-if="paginator.currentPage > 1"
            type="primary"
            icon="fas fa-arrow-left"
            size="small"
            @click="loadEvalCompetencies(paginator.currentPage - 1)"
          >
            Предыдущая компетенция
          </el-button>
          <el-button
            :disabled="loading || !allIndicatorsSelected"
            type="primary"
            size="small"
            v-if="paginator.currentPage < paginator.totalCount"
            @click="loadEvalCompetencies(paginator.currentPage + 1)"
          >
            Следующая компетенция
            <i class="fas fa-arrow-right"></i>
          </el-button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="show = false">Закрыть</el-button>
        <el-button
          v-if="!loading && !disabled_evaluate() && allIndicatorsSelected && paginator.currentPage === paginator.totalCount"
          type="primary"
          size="small"
          icon="fas fa-clipboard-check"
          @click="finishEvaluation"
        >
          Завершить оценку
        </el-button>
      </div>
    </el-dialog>
    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: "evaluate-evaluatee-dialog",
  data() {
    return {
      evaluatee: {},
      selectedOptions: {},
      indicatorComments: {},
      competencies: [],
      paginator: {},
      scale: null,
      loading: false,
      show: false,
    }
  },
  computed: {
    allIndicatorsSelected() {
      return this.competencies.every(comp =>
        comp.competence.indicators.every(indicator => this.selectedOptions[indicator.id])
      );
    }
  },
  methods: {
    disabled_evaluate() {
      return this.evaluatee && this.evaluatee.status === 'evaluated'
    },
    loadEvalCompetencies(page) {
      this.loading = true;
      this.$api.evaluation.myEvaluationGetCompetencies({
        request_id: this.evaluatee.id,
        page: page,
        'per-page': 1,
        sort: 'id',
      })
        .then(({ data }) => {
          this.competencies = data.competencies;
          this.scale = data.scale;
          this.paginator = data._paginator;

          const selected = {};
          const comments = {};

          for (const competency of data.competencies) {
            for (const indicator of competency.competence.indicators) {
              if (indicator.result) {
                selected[indicator.id] = indicator.result.score_option_id;
                comments[indicator.id] = indicator.result.comment || '';
              }
            }
          }

          this.selectedOptions = selected;
          this.indicatorComments = comments;
        })
        .finally(() => {
          this.loading = false;

          this.$nextTick(() => {
            const dialogWrapper = this.$refs.dialog?.$el;
            if (dialogWrapper) {
              dialogWrapper.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
            }
          });
        })
    },
    saveEvaluation(indicatorId, optionId) {
      if (!optionId) return;
      this.$set(this.selectedOptions, indicatorId, optionId);
      const comment = this.indicatorComments[indicatorId] || null;

      this.$api.evaluation.myEvaluationSaveEvaluationScore({
        evaluation_id: this.evaluatee.evaluation_id,
        request_id: this.evaluatee.id,
        indicator_id: indicatorId,
        score_option_id: optionId,
        comment: comment,
      });
    },
    finishEvaluation() {
      this.loading = true;
      this.$api.evaluation.myEvaluationFinishEvaluation({
        request_id: this.evaluatee.id,
      }).finally(() => {
        this.$emit("refresh-eval-user");
        this.$emit("refresh-evaluatee");
        this.$emit("refresh-my-evaluatee");

        this.loading = false;
        this.show = false;
      })
    },
    open(evaluatee) {
      this.evaluatee = evaluatee;
      this.show = true;
      this.page = 1;
      this.loadEvalCompetencies();
    },
  }
}
</script>

<style>
  .block-empty {
    border: 2px solid #e6e6e7;
    padding: 30px;
    border-radius: 10px;
    text-align: center;
    color: #6b7074;
    font-weight: bold;
  }

  .evaluation-scale-radio label {
    display: block;
    margin-top: 20px;
    width: fit-content;
  }

  .indicator {
    border: 1px solid #DCDFE6;
    position: relative;
    margin-top: 35px;
    padding: 20px;
  }

  .comment {
    margin-top: 15px;
  }

  .indicator-name {
    padding: 5px;
    background-color: white;
    top: -15px;
    left: 15px;
    margin: -34px 0 0 0;
    width: fit-content;
  }

  .button-block {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0 20px 0;
  }

  .button-block {
    width: 100%;
    align-items: center;
  }

  .button-block button {
    display: block;
  }

  .button-block button:first-child {
    justify-self: start;
  }

  .button-block button:last-child {
    justify-self: end;
  }

  .button-block .fa-arrow-right {
    margin-left: 5px;
  }
</style>